import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";

/**
 * When the user is owner-portal-only, returns whether they own the given property.
 * Query is disabled for staff — callers should treat undefined / idle as "allowed".
 */
export function useOwnerPropertyAccess(propertyId: number | null) {
  const { user, isOwnerPortalOnly } = useAuth();
  const enabled = isOwnerPortalOnly && !!propertyId && !!user?.id;

  return useQuery({
    queryKey: ["v2", "owner-property-access", user?.id, propertyId],
    enabled,
    queryFn: async (): Promise<boolean> => {
      const { data, error } = await supabase
        .from("property_owners")
        .select("property_id")
        .eq("user_id", user!.id)
        .eq("property_id", propertyId!)
        .maybeSingle();
      if (error) throw error;
      return data != null;
    },
  });
}
